"use client";

import { useHostDetailsQuery, useHostListingsQuery } from "../api/queries";
import { hostService } from "../services";
import type { IHostListingQuery } from "../types";

const DEFAULT_QUERY: IHostListingQuery = { page: 1, limit: 10 };

/** A host's profile and listings, fetched in parallel. A 404 means "no host", not an error. */
export function useHostWithListings(
  hostId: number,
  query: IHostListingQuery = DEFAULT_QUERY,
) {
  const details = useHostDetailsQuery(hostId);
  const listings = useHostListingsQuery(hostId, query);

  return {
    hostDetails: details.data?.data,
    listings: listings.data?.data ?? [],
    meta: listings.data?.meta,
    isLoading: details.isLoading || listings.isLoading,
    error:
      hostService.failure(details.error) ?? hostService.failure(listings.error),
  };
}
